import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { vendors } from '@/mocks/vendors';
import { categoryData } from '@/mocks/categories';

const tabs = [
  { value: 'all', label: '전체' },
  { value: 'dress', label: '예복' },
  { value: 'jewelry', label: '예물' },
  { value: 'hanbok', label: '한복' },
];

const reviewPhotos = vendors.flatMap((v) => [
  {
    id: `${v.id}-1`,
    vendorId: v.id,
    vendorName: v.name,
    category: v.category,
    image: v.image,
    keywords: v.tags.slice(0, 2),
  },
]);

export default function Reviews() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');

  const filtered = activeTab === 'all'
    ? reviewPhotos
    : reviewPhotos.filter((r) => r.category === activeTab);

  return (
    <div className="min-h-[100dvh] bg-cream flex flex-col">
      <div className="px-5 pt-6 pb-3 bg-white border-b border-cream-dark">
        <div className="flex items-center gap-2 mb-4">
          <button
            onClick={() => navigate('/home')}
            className="w-8 h-8 flex items-center justify-center text-navy cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl" />
          </button>
          <h1 className="text-navy text-xl font-bold">실제 후기 사진</h1>
        </div>
        <div className="flex gap-2 overflow-x-auto scrollbar-hide">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              onClick={() => setActiveTab(tab.value)}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                activeTab === tab.value
                  ? 'bg-navy text-white'
                  : 'bg-cream text-navy border border-cream-dark hover:border-beige'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-5 py-4">
        <div className="columns-2 gap-2 space-y-2">
          {filtered.map((photo, index) => {
            const cat = categoryData[photo.category as keyof typeof categoryData];
            return (
              <button
                key={photo.id}
                onClick={() => navigate(`/vendor/${photo.vendorId}`)}
                className={`block w-full break-inside-avoid rounded-xl overflow-hidden text-left cursor-pointer hover:shadow-sm transition-shadow ${
                  index % 3 === 0 ? 'aspect-[3/4]' : 'aspect-square'
                }`}
              >
                <div className="relative w-full h-full">
                  <img
                    src={photo.image}
                    alt={photo.vendorName}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <div className="absolute bottom-2 left-2 right-2">
                    <span
                      className="px-1.5 py-0.5 rounded text-[10px] font-medium"
                      style={{ backgroundColor: `${cat.color}30`, color: '#fff' }}
                    >
                      {cat.name}
                    </span>
                    <p className="text-white text-xs font-medium mt-1 truncate">{photo.vendorName}</p>
                    <div className="flex flex-wrap gap-1 mt-1">
                      {photo.keywords.map((k) => (
                        <span key={k} className="text-white/70 text-[10px]">#{k}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}